import { Navigate } from "react-router";

// Mirrors `web/src/app/page.tsx` — the root path redirects to the
// canary route. Once phase 2 lands every route, this becomes a real
// dashboard landing.
export function HomeRedirect() {
  return <Navigate to="/exceptions" replace />;
}
